
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class AsideBar extends Vue {
  @Prop() visible!: boolean;
  @Prop() src!: string;

  selfVisible = false;
  playState = "pause";

  @Watch("visible", { immediate: true })
  onVisibleChange(val: boolean) {
    this.selfVisible = val;
  }

  get isMp4() {
    return this.src.indexOf(".mp4") > -1;
  }

  playAndPause() {
    const video = this.$refs.video as HTMLVideoElement;
    if (!video) {
      return;
    }
    if (this.playState === "pause") {
      video.play();
      this.playState = "play";
    } else {
      video.pause();
      this.playState = "pause";
    }
  }

  close() {
    this.$emit("update:visible", false);
  }

  mounted() {
    window.addEventListener("click", this.close);
  }

  beforeDestory() {
    const video = this.$refs.video as HTMLVideoElement;
    if (video) {
      video.pause();
    }
    window.removeEventListener("click", this.close);
  }
}
